namespace GeniuzPOS.Purchase {
    export class PoPurRequestAppColumns {
        static columnsKey = 'Purchase.PoPurRequestApp';
    }
}
